export enum ScenarioStatus{
    ZERO,
    DRAFT,
    REVIEW,
    EDITING,
    APPROVED,
    PUBLISHED,
    ARCHIVED,
}
